import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=48ce1b98&scoped=true"
import script from "./taskDetail.vue?vue&type=script&lang=js"
export * from "./taskDetail.vue?vue&type=script&lang=js"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=48ce1b98&prod&lang=scss&scoped=true"
import style1 from "./taskDetail.vue?vue&type=style&index=1&id=48ce1b98&prod&lang=scss&scoped=true"
import style2 from "./taskDetail.vue?vue&type=style&index=2&id=48ce1b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce1b98",
  null
  
)

export default component.exports